import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';

import type { ModelCertificate } from '@app/api/Certificates';
import { generateSpanWithDataTestId } from '@app/shared/utils';
import { formatAmount } from '@app/shared/utils/formatAmount';

import { CERTIFICATES_EMPTY_NAME } from './constants';

import type { CertificatesColumnsHandlers } from '../types';
import type { ColumnsType } from 'antd/es/table';

const EDIT_LABEL = 'Редактировать сертификат';
const DELETE_LABEL = 'Удалить сертификат';

export const getCertificatesColumns = ({
  onEdit,
  onDelete,
  canEdit,
  canDelete,
}: CertificatesColumnsHandlers): ColumnsType<ModelCertificate> => {
  const columns: ColumnsType<ModelCertificate> = [
    {
      title: generateSpanWithDataTestId('Название', 'certificate-name-title'),
      dataIndex: 'Name',
      key: 'Name',
      width: 320,
      ellipsis: true,
      render: (_, certificate) =>
        certificate.Name?.trim() || CERTIFICATES_EMPTY_NAME,
    },
    {
      title: generateSpanWithDataTestId(
        'Стоимость, ₽',
        'certificate-cost-title'
      ),
      dataIndex: 'Cost',
      key: 'Cost',
      width: 160,
      align: 'right',
      render: (cost: number) => formatAmount(cost),
    },
  ];

  if (!canEdit && !canDelete) {
    return columns;
  }

  columns.push({
    title: '',
    key: 'actions',
    width: 100,
    align: 'right',
    fixed: 'right',
    render: (_, certificate) => (
      <div className="Certificates__row-actions">
        {canEdit && (
          <Tooltip title={EDIT_LABEL}>
            <Button
              type="text"
              icon={<EditOutlined />}
              onClick={() => onEdit(certificate)}
              data-testid="edit-certificate"
              aria-label={EDIT_LABEL}
            />
          </Tooltip>
        )}
        {canDelete && (
          <Tooltip title={DELETE_LABEL}>
            <Button
              type="text"
              danger
              icon={<DeleteOutlined />}
              onClick={() => onDelete(certificate)}
              data-testid="delete-certificate"
              aria-label={DELETE_LABEL}
            />
          </Tooltip>
        )}
      </div>
    ),
  });

  return columns;
};
